import { createFileRoute } from "@tanstack/react-router";
import { blogRouteOptions } from "@/components/blog/blogRouteOptions";

export const Route = createFileRoute("/topical-authority-and-clusters")(blogRouteOptions("topical-authority-and-clusters"));
